module.exports = __webpack_public_path__ + "img/graphic2.fb4a7896.svg";